import EmptySec from "./EmptySec";
import FooterSec from "./FooterSec";
import HowIWork from "./HowIWorkSec";
import MyPortfolio from "./MyPortfolio";
import MyTerms from "./MyTerms";
import ReviewSec from "./ReviewSec";
import ToolsSec from "./ToolsSec";

export default function Segment6(){
    return(
    <div className="seg4">
        <MyPortfolio/>
        <FooterSec/>
    </div>
    )
}